export default "__VITE_ASSET__DyLLSq5b__"